import Vue from 'vue';

Vue.directive('blur-on-focus', {
  bind(el) {
    el.addEventListener('focus', () => {
      el.blur();
    });
  },
});

let handleOutsideClick;
Vue.directive('closable', {
  bind(el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation();

      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;

      exclude.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };

    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  },
  unbind() {
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('touchstart', handleOutsideClick);
  },
});

Vue.directive('select-box', {
  bind(el) {
    const iconDropDown = el.getElementsByClassName('icon--dropdown')[0];
    let open = false;
    iconDropDown.addEventListener('click', () => {
      const input = el.getElementsByTagName('input')[0] || el.getElementsByTagName('select')[0];
      if (open) {
        open = false;
      } else {
        input.focus();
        open = true;
      }
    });
  },
});

Vue.directive('link-stop-bubbling', {
  bind(el) {
    const element = el;
    element.$stopBubbling = (e) => {
      if (e.target.tagName === 'A') e.stopPropagation();
    };
    element.addEventListener('click', el.$stopBubbling);
  },
  unbind(el) {
    if (el.$stopBubbling) el.removeEventListener('click', el.$stopBubbling);
  },
});

Vue.directive('phone-format', {
  bind(el) {
    el.addEventListener('mouseout', (event) => {
      let phoneNumber = event.target.value;
      if (phoneNumber) {
        phoneNumber = phoneNumber.replace(/\s/g, '');
      }
      event.target.value = phoneNumber;
    });
  },
});
